<template>
  <div
    :style="{ height: type == 'showAll' ? '160px' : '50px' }"
    class="mini_app1"
    :class="['is-' + effect]"
  >
    <!-- 垂直 -->
    <div v-if="type === 'vertical'" class="vertical_app" @click="loadApp">
      <div class="vertical_app-icon">
        <img :src="data.servicePicUrl || data.iconUrl" class="keep-hue" />
      </div>
      <span class="vertical_app-name" v-if="name">{{ name }}</span>
      <div v-if="hoverEffect" class="vertical_app-hover keep-hue">
        <h4>
          <span>{{ name }}</span>
          <sw-icon
            icon="heart"
            :class="
              data.collect === '1'
                ? 'mini_app1-collected'
                : 'mini_app1-uncollect'
            "
            @click.stop.native="collectApp"
          ></sw-icon>
        </h4>
        <img :src="data.servicePicUrl || data.iconUrl" class="keep-hue" />
        <div class="vertical_app-hover-info">
          <div :title="data.contactInformation" v-if="data.contactInformation">
            电话：{{ data.contactInformation }}
          </div>
          <br />
          <div
            :title="data.serviceDepartmentName"
            v-if="data.serviceDepartmentName"
          >
            部门：{{ data.serviceDepartmentName }}
          </div>
        </div>
      </div>
    </div>
    <!-- 垂直添加 -->
    <div class="vertical_app-insert" v-else-if="type === 'vertical-insert'">
      <i class="el-icon-more"></i>
    </div>
    <!-- 垂直 - 更多 -->
    <div class="vertical_app-more" v-else-if="type === 'vertical-more'">
      <i class="el-icon-more"></i>
    </div>
    <!-- 水平 -->
    <div
      v-else-if="type === 'horizontal' || type === 'recently'"
      class="horizontal_app"
      :class="['horizontal_app--' + type, 'horizontal_app--' + size]"
      @click="loadApp"
      style="display: flex;"
    >
      <img :src="data.servicePicUrl || data.iconUrl" class="keep-hue" />

      <span class="horizontal_app-name" v-if="name">{{ name }}</span>
      <img
        class="keep-hue"
        src="@/assets/Service/tuijian@2x.svg"
        alt=""
        style="width: 16px; height: 18px;"
        v-if="type !== 'recently' && data.recommend == '1'"
      />

      <div
        class="heart"
        @click.stop="collectApp"
        style="
          display: none;
          margin-right: 10px;
          flex: 1;
          text-align: right;
          cursor: pointer;
        "
      >
        <sw-icon
          icon="heart"
          :class="{
            'mini_app1-collected1': collect === '1' && buttonId,
            'mini_app1-collected': collect === '1',
            'mini_app1-uncollect1': collect !== '1' && buttonId,
            'mini_app1-uncollect': collect !== '1',
          }"
        ></sw-icon>
      </div>
    </div>
    <div v-else-if="type === 'showAll'" @click="loadApp">
      <div class="horizontal_app-showAll keep-hue">
        <img
          src="@/assets/Service/tuijian@2x.svg"
          alt=""
          class="posImg"
          v-if="data.recommend == '1'"
        />
        <h4>
          <span :title="name">{{ name }}</span>
          <span class="guide" @click.stop="showApplicationInfo(data)">
            <svg-icon icon="guide"></svg-icon>
          </span>
        </h4>
        <div class="horizontal_app-showAll-divider"></div>
        <img :src="data.servicePicUrl || data.iconUrl" />
        <div class="horizontal_app-showAll-info">
          <div
            class="horizontal_app-showAll-info-c"
            :style="{
              'margin-top':
                data.contactInformation && data.serviceDepartmentName
                  ? '0px'
                  : '10px',
            }"
          >
            <div
              :title="data.contactInformation"
              v-if="data.contactInformation"
            >
              电话：{{ data.contactInformation }}
            </div>
            <div
              :title="data.serviceDepartmentName"
              v-if="data.serviceDepartmentName"
            >
              部门：{{ data.serviceDepartmentName }}
            </div>
          </div>
        </div>
        <div class="eye-filled">
          <div
            class="unlineHand"
            v-if="
              data.unlineHand == '1' ||
              data.unlineHand == '2' ||
              data.runTime >= 2
            "
          >
            <span v-if="data.unlineHand == '1' || data.unlineHand == '2'">
              {{ data.unlineHand == '2' ? '线上或线下' : '线下' }} </span
            ><span v-if="data.runTime >= 2"
              >跑{{ data.runTime > 3 ? '3次以上' : data.runTime + '次' }}</span
            >
          </div>
          <div
            :style="{
              display: 'flex',
              width:
                data.unlineHand == '1' ||
                data.unlineHand == '2' ||
                data.runTime >= 2
                  ? 'auto'
                  : '100%',
              'min-height': '25px',
            }"
          >
            <div
              class="eye-filled1"
              :style="{
                flex:
                  data.unlineHand == '1' ||
                  data.unlineHand == '2' ||
                  data.runTime >= 2
                    ? 'none'
                    : '1',
              }"
            >
              <img
                :src="require('@/assets/Service/news-icon-look@2x.svg')"
                style="
                  width: 14px;
                  height: 10px;
                  margin-top: 4px;
                  margin-right: 6px;
                "
              />
              <span style="font-size: 12px;">{{ data.clickNum }}</span>
            </div>
            <div class="heart" @click.stop="collectApp">
              <sw-icon
                icon="heart"
                :class="{
                  'mini_app1-collected1': collect === '1' && buttonId,
                  'mini_app1-collected': collect === '1',
                  'mini_app1-uncollect1': collect !== '1' && buttonId,
                  'mini_app1-uncollect': collect !== '1',
                }"
              ></sw-icon
              ><span style="font-size: 12px;">{{ collectNum }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BusinessGuideNew
      v-if="businessGuideVisible"
      :serveUrl="serveUrl"
      :openApi="openApi"
      :currentApp="data.id"
      :businessGuideVisible="businessGuideVisible"
      @close="businessGuideVisible = false"
      :request="request"
      :serveUrlD="data.serviceUrl"
    ></BusinessGuideNew>
    <el-dialog
      append-to-body
      :visible.sync="showServeUrl"
      :class="{
        'createApp-dialog1': showDialog,
        'createApp-dialog2': !showDialog,
        'createApp-dialogA': true,
      }"
    >
      <div
        style="
          position: absolute;
          height: 60px;
          top: 0px;
          left: 0px;
          background: rgba(0, 0, 0, 0.4);
          width: 100%;
          border-radius: 10px 10px 0 0;
        "
      ></div>
      <div
        style="
          position: absolute;
          top: 0px;
          width: 100%;
          padding: 0 30px;
          display: flex;
          border-radius: 10px 10px 0 0;
        "
      >
        <div style="flex: 1; display: flex; width: 100%;">
          <img
            :src="data.servicePicUrl || data.iconUrl"
            alt=""
            style="margin-top: 15px;"
            width="30px"
            height="30px"
          />
          <div
            style="
              padding-left: 10px;
              flex: 1;
              margin-top: 19px;
              font-size: 18px;
              color: #fff;
            "
          >
            {{ name }}
          </div>
        </div>
        <div style="margin-top: 11px; flex: 1;">
          <div v-if="showDialog" class="button">
            <img
              src="@/assets/Service/maxM.svg"
              width="20px"
              height="20px"
              style="margin-right: 20px;"
              @click="showDialog = false"
            />
            <img
              src="@/assets/Service/close.svg"
              width="20px"
              height="20px"
              @click="showServeUrl = false"
            />
          </div>
          <div v-else class="button">
            <img
              src="@/assets/Service/moreM.svg"
              width="20px"
              height="20px"
              style="margin-right: 20px;"
              @click="showDialog = true"
            />
            <img
              src="@/assets/Service/close.svg"
              width="20px"
              height="20px"
              @click="showServeUrl = false"
            />
          </div>
        </div>
      </div>
      <iframe
        :src="data.serviceUrl"
        :key="'iframe-' + data.serviceUrl"
        allowfullscreen="true"
        allow="autoplay"
        frameborder="0"
        width="100%"
        class="keep-hue iframe"
        v-ratio="{ ratio: 16 / 9, fixed: 'width', keep: true, debounce: 100 }"
      ></iframe>
    </el-dialog>
    <el-drawer
      :visible.sync="showApplication"
      :append-to-body="true"
      :show-close="false"
      :withHeader="false"
      custom-class="applicationDrawer"
      size="380px"
    >
      <div class="applicationDrawer-head">
        <span class="applicationDrawer-head-img"
          ><img :src="drawerData.servicePicUrl"
        /></span>
        <div class="applicationDrawer-head-right">
          <p class="title">{{ drawerData.serviceName }}</p>
          <div class="handle" @click="handleService(drawerData)">
            <el-button type="primary" round>办理服务</el-button>
          </div>
        </div>
      </div>
      <div class="applicationDrawer-info">
        <div class="applicationDrawer-subTitle">
          基本信息
        </div>
        <ul>
          <li v-for="item in infoSetting">
            <span class="labelName" v-html="item.labelName"></span>
            <template v-if="item.labelVal === 'serviceSource'">
              <span class="labelVal">{{
                drawerData[item.labelVal] || '应用系统'
              }}</span>
            </template>
            <template v-else>
              <span class="labelVal">{{
                drawerData[item.labelVal] || '-'
              }}</span>
            </template>
          </li>
          <li>
            <span class="labelName">0条评价</span>
            <span class="rate">
              <el-rate
                v-model="drawerData.value || 0"
                disabled
                text-color="#ff9900"
                disabled-void-color="#cccccc"
                score-template="{0}"
              >
              </el-rate>
            </span>
            <span style="flex-grow: 1;"></span>
            <span class="collectionNum"
              >{{ drawerData.collectNum || 0 }}人已收藏</span
            >

            <span>
              <template
                v-if="drawerData.collect && drawerData.collect.trim() !== '1'"
              >
                <svg-icon icon="collection" class="keep-hue fz16"></svg-icon>
              </template>
              <template v-else>
                <svg-icon icon="collectioned" class="keep-hue fz16"></svg-icon>
              </template>
            </span>
          </li>
        </ul>
      </div>
      <div class="applicationDrawer-bottom">
        <div class="applicationDrawer-bottom-tabs">
          <div
            class="drawer-active-bar"
            :style="{ left: drawerActive * (56 + 27) + 'px' }"
          ></div>
          <div
            class="applicationDrawer-bottom-tabs-li"
            :class="drawerActive === index ? 'active' : ''"
            v-for="(item, index) in drawerBottomModule"
            :key="index"
            @click="changeDrawerColumn(index)"
          >
            {{ item.name }}
          </div>
        </div>

        <div
          v-if="drawerActive === 0"
          class="applicationDrawer-bottom-serviceInfo"
        >
          {{ drawerData.serviceDesc || drawerData.serviceName }}
        </div>
        <div
          v-if="drawerActive === 1"
          class="applicationDrawer-bottom-serviceInfo"
        >
          功能完善中，敬请期待！
        </div>
      </div>
    </el-drawer>
    <!-- <juhefuweu :dataList="dataList" v-if="showDialogJuhe"></juhefuweu> -->
  </div>
</template>

<script>
import {
  changeCollectService,
  postRecentServe,
} from 'portal-component/src/api/Serve/'
import { getServiceDetails } from '@/api/serviceN'
import req from '@/utils/request'
import configR from '@/configs.js'
import { loadRemoteComponent } from '@/utils/loadRemoteComponent'
export default {
  name: 'MiniApp',
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      },
    },
    type: { type: String, default: 'vertical' },
    effect: { type: String, default: 'light' },
    size: { type: String, default: 'medium' },
    name: { type: String },
    icon: { type: String },
    hoverEffect: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    button: { type: String },
    serveUrl: { type: String, required: true },
    request: { type: Function, default: req },
    openApi: { type: Boolean, default: false },
    loginUrl: { type: String },
    selectheart: { type: Boolean, default: false },
  },
  // components: {
  //   juhefuweu: async () =>
  //     await loadRemoteComponent(
  //       'http://localhost:9002/remoteEntry.js',
  //       'aggregateServices'
  //     ),
  // },
  data() {
    return {
      showDialog: true,
      showServeUrl: false,
      isCollected: false,
      businessGuideVisible: false,
      buttonId: false,
      showDialogJuhe: false,
      dataList: {},
      collect: '0',
      collectNum: 0,
      drawerData: {},
      showApplication: false,
      infoSetting: [
        {
          labelName: '来&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;源:',
          labelVal: 'serviceSource',
        },
        {
          labelName: '上线时间:',
          labelVal: 'releaseTime',
        },
        {
          labelName: '发布单位:',
          labelVal: 'serviceDepartmentName',
        },
        {
          labelName: '联系方式:',
          labelVal: 'contactInformation',
        },
      ],
      drawerActive: 0,
      drawerBottomModule: [{ name: '服务简介' }, { name: '用户评价' }],
    }
  },
  watch: {
    businessGuideVisible: {
      handler: function (val) {
        console.log('val', val)
      },
    },
  },

  created() {
    this.data.collect === '1'
      ? (this.isCollected = true)
      : (this.isCollected = false)
    this.collect = this.data.collect
    this.collectNum = this.data.collectNum
    this.getCommint()
  },
  methods: {
    async getCommint() {
      let Module = await loadRemoteComponent(
        'http://localhost:9002/remoteEntry.js',
        'aggregateServices'
      )
      console.log('Module', Module)
    },
    handleService() {
      window.open(this.data.serviceUrl, '_blank', 'noopener noreferrer')
      this.showApplication = false
    },
    changeDrawerColumn(index) {
      this.drawerActive = index
    },
    showApplicationInfo(data) {
      this.showApplication = true
      this.drawerData = data || {}
    },
    collectApp() {
      if (this.openApi) {
        window.location.href = this.loginUrl
        return
      }
      // this.$parent.getServiceListNData();
      let data = {
        request: this.request,
        serveUrl: this.serveUrl,
        id: this.data.id,
        collect: this.isCollected ? '1' : '0',
        header: 'portal',
      }
      changeCollectService(data).then((res) => {
        if (res.code == 0) {
          this.isCollected = !this.isCollected
          this.buttonId = true

          this.data.collect === '0'
            ? (this.data.collect = '1')
            : (this.data.collect = '0')
          if (this.data.collect === '1') {
            this.data.collectNum = this.data.collectNum + 1
          } else {
            if (this.data.collectNum <= 0) {
              return false
            } else {
              this.data.collectNum = this.data.collectNum - 1
            }
          }
        }
        this.collect = this.data.collect
        this.collectNum = this.data.collectNum
      })
    },
    // 打开 APP
    async loadApp() {
      if (this.data.onlyShowIcon) {
        this.$message.error('暂无数据！')
        return false
      }
      if (this.data.serviceType == '5') {
        let res = await getServiceDetails(this.data.id)
        if (res.code == 0) {
          this.dataList.serviceName = this.data.serviceName
          this.dataList.servicePicUrl = this.data.servicePicUrl
          this.dataList.containServices = res.data.containServices
          this.showDialogJuhe = true
        }
      } else {
        let data = {
          request: this.request,
          serveUrl: this.serveUrl,
          id: this.data.id,
          header: 'portal',
        }
        postRecentServe(data)
        if (this.data.haveGuide === '0') {
          let url = this.data.serviceUrl
          if (url.indexOf('?iframe=true') != -1) {
            this.showServeUrl = true
          } else {
            if (window.VBArray) {
              let referLink = document.createElement('a')
              referLink.href = url
              if (
                configR.envConfigs.EXTERNAL_LINKS === '1'
              ) {
                referLink.target = '_blank'
              }
              //
              document.body.appendChild(referLink)
              referLink.click()
            } else {
              window.open(url)
            }
          }
        } else {
          this.businessGuideVisible = true
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.horizontal_app--medium > img {
  width: 30px;
  height: 30px;
}

.horizontal_app > span {
  width: auto;
}
.horizontal_app {
  .posImg {
    width: 16px;
    height: 16px;
    box-shadow: none;
  }
}
.horizontal_app-hover {
  height: 142px;
  .posImg {
    top: 59px;
    left: 10px;
  }
  .quantity {
    text-align: right;
    font-size: 12px;
  }
}
.createApp-dialog2 {
  /deep/ .el-dialog {
    width: 100%;
    // max-width: 1920px;
    height: 100%;
    margin: 0px auto !important;
  }
}
.createApp-dialogA {
  overflow: hidden;
  .button {
    float: right;
    cursor: pointer;
    i {
      font-size: 16px;
      font-weight: 700;
    }
    line-height: 43px;
    color: #909399;
    cursor: pointer;
  }
  .button:hover {
    color: #0e6ccb;
  }
  .iframe {
    height: 90% !important;
  }
  /deep/.el-dialog {
    border-radius: 10px;
    max-width: 1920px;
    .el-dialog__header {
      background: #0e6ccb;
      border-radius: 10px 10px 0 0;
      height: 60px;
    }
    .el-dialog__body {
      height: 100%;
      padding: 0px;
    }
    .el-dialog__headerbtn {
      display: none;
    }
    // .el-dialog__headerbtn .el-dialog__close {
    //   font-weight: 700;
    //   font-size: 16px;
    // }
  }
}
.createApp-dialog1 {
  /deep/ .el-dialog {
    width: 1280px;
    margin: auto !important;
    height: 90%;
    //margin:5% auto;
  }
}
</style>
